
import {
  defineComponent, ref, Ref, onMounted,
} from 'vue';
import { useRouter } from 'vue-router';
import { Form, defineRule } from 'vee-validate';
import AppInput from '@/components/UI/AppInput.vue';
import AppButton from '@/components/UI/AppButton.vue';
import ValidationService from '@/services/ValidationService';
import { useRegistrationStore } from '../store/registrationStore';
// eslint-disable-next-line import/no-cycle
import MonitoringService from '@/services/MonitoringService';

defineRule('required', (value:string) => ValidationService.isNotEmpty(value) || 'This field is required');

export default defineComponent({
  components: {
    Form,
    AppInput,
    AppButton,
  },
  setup() {
    const schema = {
      lastName: 'required',
    };

    const router = useRouter();
    const registrationStore = useRegistrationStore();

    const lastNameValue: Ref<string> = ref(registrationStore.searchUser.lastName);

    function nextStep() {
      registrationStore.searchUser.lastName = lastNameValue.value;
      if (registrationStore.createUser.hippa) {
        router.push('step-3');
      } else {
        router.push('step-5');
      }
    }

    onMounted(() => {
      if (!registrationStore.searchUser.firstName) {
        router.push('healthcare');
      }
      MonitoringService.sendPageMountedSpeed();
    });

    return {
      schema,
      lastNameValue,
      nextStep,
    };
  },
});
